import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "mb-3 error__message-container"
};
const _hoisted_2 = { class: "row align-middle mt-4" };
const _hoisted_3 = { class: "col-sm-7 my-auto align-middle pr-0 d-flex justify-content-center justify-content-sm-start mb-3 mb-sm-2" };
const _hoisted_4 = /*#__PURE__*/ _createTextVNode(" | ");
const _hoisted_5 = { class: "col-sm-5 col-12 text-end pl-0" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_text_field = _resolveComponent("g-text-field");
    const _component_router_link = _resolveComponent("router-link");
    const _component_g_button = _resolveComponent("g-button");
    const _component_g_simple_page = _resolveComponent("g-simple-page");
    return (_openBlock(), _createBlock(_component_g_simple_page, {
        title: _ctx.$tc('homePage.Titel')
    }, {
        default: _withCtx(() => [
            _createElementVNode("form", null, [
                _createVNode(_component_g_text_field, {
                    dataObject: _ctx.$data,
                    dataMember: "userName",
                    label: _ctx.$tc('account.UserNameEMail') + '*',
                    mode: "email",
                    "data-mode": "model",
                    "show-clear-button": false,
                    onEnterKey: _ctx.runLogin
                }, null, 8, ["dataObject", "label", "onEnterKey"]),
                _createVNode(_component_g_text_field, {
                    dataObject: _ctx.$data,
                    dataMember: "password",
                    label: _ctx.$tc('account.Password') + '*',
                    mode: "password",
                    "data-mode": "model",
                    onEnterKey: _ctx.runLogin,
                    autocomplete: "on"
                }, null, 8, ["dataObject", "label", "onEnterKey"]),
                (_ctx.hasError)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.errorMessage), 1))
                    : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("span", null, [
                        _createVNode(_component_router_link, {
                            to: "/login/recovery",
                            tabindex: "-1"
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$tc('account.ForgotPassword')), 1)
                            ]),
                            _: 1
                        }),
                        _hoisted_4,
                        _createVNode(_component_router_link, {
                            to: "/login/register",
                            tabindex: "-1"
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$tc('account.Register')), 1)
                            ]),
                            _: 1
                        })
                    ])
                ]),
                _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_g_button, {
                        text: _ctx.$tc('account.Login'),
                        "is-loading": _ctx.isLoading,
                        disabled: _ctx.disableLogin,
                        onClick: _ctx.runLogin
                    }, null, 8, ["text", "is-loading", "disabled", "onClick"])
                ])
            ])
        ]),
        _: 1
    }, 8, ["title"]));
}
